import React from "react";
import { Icon, Skeleton, cx } from "./core";

/**
 * Page head: breadcrumb, a sentence-case title, one line of context in t-small (which run, when sealed,
 * ET then AEST) and right-aligned actions. Every screen starts with one.
 */
export function PageHead({ crumb, title, context, actions, children, className, ...rest }) {
  const trail = crumb == null ? [] : Array.isArray(crumb) ? crumb : [crumb];
  return (
    <div {...rest} className={cx("sn-page-head", className)}>
      <div className="sn-stack" style={{ gap: 4, minWidth: 0 }}>
        {trail.length > 0 && (
          <nav className="sn-crumb" aria-label="Breadcrumb">
            {trail.map((c, i) => (
              <React.Fragment key={i}>
                {i > 0 && <Icon name="ChevronRight" size={12} />}
                <span>{c}</span>
              </React.Fragment>
            ))}
          </nav>
        )}
        <h1>{title}</h1>
        {context && <p className="sn-small sn-muted" style={{ margin: 0 }}>{context}</p>}
        {children}
      </div>
      {actions && <div className="sn-page-actions">{actions}</div>}
    </div>
  );
}

/** Placeholder while a screen's first query resolves. */
export function PageLoading({ label = "Loading", lines = 4 }) {
  return (
    <div className="sn-stack" aria-busy="true" aria-label={label}>
      <Skeleton width="40%" height={24} />
      <Skeleton lines={lines} />
    </div>
  );
}

/** A grid of 12 columns that collapses to one column on mobile. Children use `sn-col-N`. */
export function Grid({ children, className, style, ...rest }) {
  return <div {...rest} className={cx("sn-grid-12", className)} style={style}>{children}</div>;
}
